import { render, staticRenderFns } from "./Post_Broadcast_Component.vue?vue&type=template&id=70ed7b06&scoped=true"
import script from "./Post_Broadcast_Component.vue?vue&type=script&lang=js"
export * from "./Post_Broadcast_Component.vue?vue&type=script&lang=js"
import style0 from "./Post_Broadcast_Component.vue?vue&type=style&index=0&id=70ed7b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed7b06",
  null
  
)

export default component.exports